// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2227) return "static/chunks/2227-d5b59e758ed4684a.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"937":"5d4983cbd3e57292","4079":"fa0559d6b9565288","4451":"e32de3075f494845","4748":"a8c51bca3f969ce8","4819":"a9c7fac37b30bc62","5315":"5bba14654f46e528","7274":"778c5f210b65e6e0","7487":"251f40021411e8a4","9795":"1698dcc6aa42c2f3"}[chunkId] + ".js";
};